const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

//const Backofficebff: any = "/api/v1";

export const CustomerCommand: any = {
    InsertBankAccount: Backofficebff + '/v1/customer/insertbankaccount',
    UpdateBankAccount: Backofficebff + '/v1/customer/updatebankaccount',
    GetCustomerAddress: Backofficebff + '/v1/customer/get-customer-list-address',
    UpdateCustomerStatus: Backofficebff + '/v1/customer/update-customer-status',
    GetOptHistoryList: Backofficebff + '/v1/customer/get-opt-historylist',
    GetCustomerStatusChangeHistoryList: Backofficebff + '/v1/customer/get-customer-status-change-history-list',
    GetCustomerLastIpAddressByCustomerId: Backofficebff + '/v1/customer/get-customer-last-ip-address',
    GetCustomerPhoneVerificationDateByPhoneNumber: Backofficebff + '/v1/customer/get-customer-phone-verification-date',
    GetCustomerOptInByCustomerId: Backofficebff + '/v1/customer/customer-optin-by-customer-id',
    GetCustomerBtPhoneNumber: Backofficebff + '/v1/customer/get-customer-phone-number',
    InsertCustomerRiskStatusChangeHistory: Backofficebff + '/v1/customer/insert-customer-risk-status-change-history',
    GetCustomerVerificationDateAndIpAddress:
        Backofficebff + '/v1/customer/get-customer-phone-verification-date-and-ip-address',
    UpdateCustomerAddress: Backofficebff + '/v1/customer/update-customer-address',
    UpdateCustomer: Backofficebff + '/v1/customer/update-customer',
    UpdateCustomerOptIn: Backofficebff + '/v1/customer/update-customer-opt-in',
    CustomerPhoneNumberChangeEmail: Backofficebff + '/v1/customer/customer-phone-number-change-email',
    GetCustomerBasketInfos: Backofficebff + '/v1/customer/get-customer-basket-informations',
    InsertCustomerValidationCode: Backofficebff + '/v1/customer/insert-customer-validation-code',
    SendUnmatchedIbanMessage: Backofficebff + '/v1/notification/send-generic-sms',
    DeleteBankAccount: Backofficebff + '/v1/customer/deletebankaccount',
    CustomerRiskStatusChangeHistoryList: Backofficebff + '/v1/customer/getcustomerriskstatusistorylist',
    SendPasswordResetSms: Backofficebff + '/v1/customer/sendpasswordresetsms',
    GetCustomerInfoByPhoneOnSSO: Backofficebff + '/v1/customer/getcustomerinfobyphoneonSSO',
    GetCustomerAnonymizedHistory: Backofficebff + '/v1/customer/getcustomeranonymizedhistory',
    CustomerAnonymize: Backofficebff + '/v1/customer/customeranonymize',
    GetOrderByCustomerId: Backofficebff + '/v1/customer/getorderbycustomerid',
    CustomerOrderSummaryList: Backofficebff + '/v1/customer/customer-order-summary-list',
    GetCustomerStoreOrderInformation: Backofficebff + '/v1/customer/get-order-information',
    GetStoreReceipt: Backofficebff + '/v1/customer/get-store-receipt',
    GetRptOrders: Backofficebff + '/v1/dynamiclive/get-rpt-orders',
    GetCustomerByIdList: Backofficebff + '/v1/customer/get-customer-by-id-list',
    UpdateRptTopic: Backofficebff + '/v1/customer/update',
    CreateRptTopic: Backofficebff + '/v1/customer/create',
    DeleteRptTopic: Backofficebff + '/v1/customer',
    SendCustomerPhoneChangeMail: Backofficebff + '/v1/customer/send-customer-phone-change-mail',
    GetShoppingCarts: Backofficebff + '/v1/customer/get-shopping-carts',
    UpdateCustomerEnd: Backofficebff + '/v1/customer/update-customer-end',
    ForcePasswordReset: Backofficebff + '/v1/customer/force-password-reset',
    IsPhoneNumberUsedBeforeThreeTimes: Backofficebff + '/v1/customer/phone-number-used-before-three-times',
    GetOptHistoryListV2: Backofficebff + '/v1/customer/get-opt-historylist-v2',
    ClearCustomerPhoneNumber: Backofficebff + '/v1/customer/clear-customer-phone-number',
    SendConfirmationCode: Backofficebff + '/v1/customer/send-confirmation-code',
    GetCustomerDiagnostics: Backofficebff + '/v1/customer/get-customer-diagnostics',
};
